/* eslint-disable */
import Actuator from '@/models/Actuator';
import actuatorService from "@/services/actuator.gasPneumatic.service";
import asBasis from "@/services/as.basis.service";
import { findValidActuatorAtMinPressure, checkValidActuatorAtMaxPressure } from "@/services/actuator.asAuto.table-values.service";

const getMasterASauto = (data: Actuator): any => {



    const securityFactorsTorques = {
        bto: data.btoSecFac,
        btoRunning: data.runningSecFac,
        eto: data.etoSecFac,
        btc: data.btcSecFac,
        btcRunning: data.runningOutSecFac,
        etc: data.etcSecFac
    }

    const actuatorAngles = {
        bto: data.btoAngle,
        btoRunning: data.runningAngle,
        eto: data.etoAngle,
        btc: data.btcAngle,
        btcRunning: data.runningOutAngle,
        etc: data.etcAngle
    }

    const torques = {
        bto: data.bto,
        btoRunning: data.running,
        eto: data.eto,
        btc: data.btc,
        btcRunning: data.runningOut,
        etc: data.etc
    }

    // Klappenwerte/Laufmomentwerte an den Winkeln aus actuatorAngles (Custom-/Standard-Drehwinkel)
    const winkelKraftObject = actuatorService.setWinkelkraft(torques, securityFactorsTorques, actuatorAngles);




    actuatorService.setKlappe();

    const controlType = data.controlType;
    const driveTypeA = data.driveTypeA;
    const driveType = data.driveType;
    const minBar = data.pressureMin;
    const maxBar = data.pressureMax;
    const MAST = data.mast;
    const tolerance = data.tolerance;
    const items = data.items;

    let minMaxBar: number[];

    if (MAST) {
        minMaxBar = [minBar, maxBar];
    } else {
        minMaxBar = [minBar, minBar + 0.5];
    }

    let knickwinkelOptions = [0, 12]
    let AS_symetric: any | undefined = undefined;
    let AS_canted: any | undefined = undefined;



    // loop for finding the actuator with the lowest pressure at knickwinkel 0 (symmetrisch, HUB_ARRAY_SYM)
    // findActuatorCandidateAtMinPressure now validates both min AND max pressure internally,
    // so optiMIN.mast is already populated when returned.
    for (let antriebIndex = 0; antriebIndex < asBasis.ANTRIEBE_ARRAY.length; antriebIndex++) {

        const maxErlaubteDrehmoment = actuatorService.setMaxNettoAntrieb(antriebIndex, tolerance, driveTypeA);

        const optiMIN = findActuatorCandidateAtMinPressure(
            knickwinkelOptions[0], antriebIndex, controlType, driveTypeA, driveType,
            items, minMaxBar[0], minMaxBar[1], maxErlaubteDrehmoment, winkelKraftObject
        );

        if (optiMIN !== undefined) {
            AS_symetric = optiMIN;
            break;
        }
    }

    // loop for finding the actuator with the lowest pressure at knickwinkel 12 (gekippt, HUB_ARRAY_CANTED)
    for (let antriebIndex = 0; antriebIndex < asBasis.ANTRIEBE_ARRAY.length; antriebIndex++) {

        const maxErlaubteDrehmoment = actuatorService.setMaxNettoAntrieb(antriebIndex, tolerance, driveTypeA);

        const optiMIN = findActuatorCandidateAtMinPressure(
            knickwinkelOptions[1], antriebIndex, controlType, driveTypeA, driveType,
            items, minMaxBar[0], minMaxBar[1], maxErlaubteDrehmoment, winkelKraftObject
        );

        if (optiMIN !== undefined) {
            AS_canted = optiMIN;
            break;
        }
    }

    if (AS_symetric && AS_canted) {

        // kriterien
        let opti = {}

        


        if (AS_symetric.antriebsIndex < AS_canted.antriebsIndex) {
            opti = AS_symetric;
        } else if (AS_symetric.antriebsIndex > AS_canted.antriebsIndex) {
            opti = AS_canted;
        } else {
            if (AS_symetric.federIndex < AS_canted.federIndex) {
                opti = AS_symetric;
            } else if (AS_symetric.federIndex > AS_canted.federIndex) {
                opti = AS_canted;
            } else {
                if (AS_symetric.zylIndex < AS_canted.zylIndex) {
                    opti = AS_symetric;
                } else if (AS_symetric.zylIndex > AS_canted.zylIndex) {
                    opti = AS_canted;
                } else {
                    // harmonische kurve
                    if (AS_symetric.antriebDrehsObj.bto < AS_canted.antriebDrehsObj.bto) {
                        opti = AS_symetric;
                    } else {
                        opti = AS_canted;
                    }
                }
            }
        }
        return {
            found: true,
            antrieb: opti
        };
    } else if (AS_symetric || AS_canted) {
        if (AS_symetric) {
            return {
                found: true,
                antrieb: AS_symetric
            };
        } else if (AS_canted) {
            return {
                found: true,
                antrieb: AS_canted
            };
        }
    } else {
        return {
            found: false,
            antrieb: undefined,
            reason: 'no actuator found'
        };
    }
};

const findActuatorCandidateAtMinPressure = (dynKnickwinkel: number, antriebIndex: number, controlType: string, driveTypeA: string, driveType: string, items: number, minBar: number, maxBar: number, maxNetActuatorTorque: number, winkelKraftObject: any) => {
    // Pass maxBar so the inner function validates both min and max pressure before returning a candidate.
    return findValidActuatorAtMinPressure({
        winkelKraftObject
    }, dynKnickwinkel, antriebIndex, controlType, driveTypeA, driveType, items, minBar, maxBar, maxNetActuatorTorque);
};

const checkActuatorCandidateAtMaxPressure = (dynKnickwinkel: number, antriebIndex: number, controlType: string, driveTypeA: string, driveType: string, zylIndex: number, federIndex: number, items: number, maxBar: number, maxNetActuatorTorque: number, winkelKraftObject: any) => {
    return checkValidActuatorAtMaxPressure({
        winkelKraftObject
    }, dynKnickwinkel, antriebIndex, controlType, driveTypeA, driveType, zylIndex, federIndex, items, maxBar, maxNetActuatorTorque);
};

const actuatorASautoService = {
    getMasterASauto
};

export default actuatorASautoService;
